export const ROUTE_PATHS = {
  HOME: '/'
} as const;

export const WHATSAPP_NUMBER = '971581350776';

export const WHATSAPP_MESSAGE = 'Hello! I would like to make a reservation at Liuyishou Chongqing Hot Pot. Could you please help me with the booking details? Thank you!';

export const GOOGLE_MAPS_URL = 'https://maps.app.goo.gl/i469V9dER7tyvoFx8';